import type { ReactNode } from 'react';
import React from 'react';
import styled from 'styled-components';

import ErrorBoundary from '@rover/components/src/errorHandling/ErrorBoundary';
import { LAYOUT } from '@rover/constants/src/search/searchPage.constants';
import MQ from '@rover/kibble/styles/MediaQuery';
import { Alignment, HorizontalLayout } from '@rover/react-lib/src/components/layouts';

import { StickyMap, StickySidebar } from '..';

const StyledHorizontalLayout = styled(HorizontalLayout)<{ $useWhiteBackground?: boolean }>`
  position: relative;

  ${MQ.SM_UP.toString()} {
    min-height: 100vh;
    padding-top: ${LAYOUT.GUTTER}px;

    background-color: ${({ theme }) => theme.background.secondary};
  }
`;

type Props = {
  children: ReactNode;
  onMarkerClick: (index: number) => void;
  onScrollableFilterChange: () => void;
};

const SearchPageLayout = ({
  children,
  onMarkerClick,
  onScrollableFilterChange,
}: Props): JSX.Element => (
  <StyledHorizontalLayout noWrap hAlign={Alignment.START} vAlign={Alignment.START}>
    <ErrorBoundary location="SearchPageLayoutSidebar">
      <StickySidebar onScrollableFilterChange={onScrollableFilterChange} />
    </ErrorBoundary>
    <ErrorBoundary location="SearchPageLayoutChildren">{children}</ErrorBoundary>
    <ErrorBoundary location="SearchPageLayoutMap">
      <StickyMap onMarkerClick={onMarkerClick} />
    </ErrorBoundary>
  </StyledHorizontalLayout>
);

export default SearchPageLayout;
